import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CategoryService } from 'src/app/services/compras/category.service';
import { ProdutoService } from 'src/app/services/compras/produto.service';
import { OrcsService } from 'src/app/services/licitacao/orcs.service';
import { PackageService } from 'src/app/services/licitacao/package.service';
import { SwalResultMessage, SwalUtil } from 'src/app/services/utils/swal.util';
import { ModalAddCategoryComponent } from './modal-add-category/modal-add-category.component';
import { ViewKitComponent } from 'src/app/compras/kit/view-kit/view-kit.component';
import { SelectSupplierProductComponent } from 'src/app/licitacao/budgets/formulario-budgets/select-supplier-product/select-supplier-product.component';

type FormType = 'PACKAGE' | 'BUDGET';
@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.css'],
})
export class ProductFormComponent
  implements OnInit, AfterContentInit, OnChanges {
  @Input('type') formType: FormType = 'PACKAGE';
  @Input() arrayProducts: any = [];
  @Input() client_id?: number;
  @Output() changeProductListEvent = new EventEmitter();
  @Output() onUpdateProductValues = new EventEmitter();

  formProduct: FormGroup;
  formSubscription: Subscription;

  inscricao: Subscription;

  ml_package_products_list: any = [];
  ml_package_products: any = [];

  products: any[] = [];
  categories: any = [];

  loadingProducts: boolean = false;
  loadingCategories: boolean = false;

  isDisabledNegative: boolean = false;

  pr: any = [];
  prs: any = [];

  tables: any = {
    simpro: 'Simpro',
    brasindice: 'Brasindíce',
    propria: 'Própria',
  };
  selectedTable: any;

  tableVersions: any;
  loadingVersion: boolean = false;

  budgetId: number;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private productService: ProdutoService,
    private budgetService: OrcsService,
    private packageService: PackageService,
    private categoryService: CategoryService,
    private swalUtil: SwalUtil,
    private dialog: MatDialog
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.arrayProducts)
      this.ml_package_products_list = changes.arrayProducts.currentValue;
  }

  ngOnInit(): void {
    this.initializeForm();
    this.inscricao = this.route.params.subscribe((params) => {
      if (params.hasOwnProperty('id')) {
        this.budgetId = params['id'];
        if (this.formType === 'PACKAGE') {
          this.loadingProducts = true;
          this.inscricao = this.packageService.find(params['id']).subscribe({
            next: (res) => {
              this.ml_package_products_list = res.ml_packages_product;
              this.loadingProducts = false;
            },
            error: (error) => {
              this.swalUtil.error(error);
            },
          });
        }
      }
    });

    this.formSubscription = this.formProduct.valueChanges.subscribe(
      (product) => {
        console.log(product)
        if (
          product.product &&
          !product.isPriceCost &&
          this.isProductWithClientRule(product.product.id)
        ) {
          const productRule = product.product.codes.find(
            (rule) => rule.client_id === Number(this.client_id)
          );

          product.priceProduct = productRule.value;
        } else {
          if (product.isPriceCost && product.product)
            product.priceProduct = product.product.cost;
          else if (!product.isPriceCost && product.product)
            product.priceProduct = product.product.sale_value;
          else product.priceProduct = 0;
        }
        product.inflator = product.valuePositive / 100;
        product.deflator = product.valueNegative / 100;
        product.valueNegative =
          (product.valueNegative / 100) * product.priceProduct;
        product.valuePositive =
          (product.valuePositive / 100) * product.priceProduct;
        product.unitary_value = product.priceProduct;
        product.end_price =
          (product.priceProduct -
            product.valueNegative +
            product.valuePositive) *
          product.quantity;
        product.subtotal =
          (product.priceProduct -
            product.valueNegative +
            product.valuePositive) *
          product.quantity;
        product.subtotal_cost = product.quantity * product.cost;
        product.monthly_cost_value = product.subtotal_cost;
        product.monthly_result_value =
          product.subtotal - product.monthly_cost_value;

        console.log(product)
      }
    );

    this.allCategories();
  }

  ngAfterContentInit(): void {
    this.inputControl();
  }

  ngOnDestroy(): void {
    if (this.formSubscription) this.formSubscription.unsubscribe();
    if (this.inscricao) this.inscricao.unsubscribe();
  }

  initializeForm(data?) {
    this.formProduct = this.formBuilder.group({
      id: null,
      table: null,
      table_version: null,
      product: [null, Validators.required],
      price: data ? data.price : 0,
      category_id: null,
      valueNegative: 0,
      valuePositive: 0,
      deflator: 0,
      inflator: 0,
      end_price: 0,
      code_tuss: data ? data.code_tuss : null,
      quantity: [1, Validators.required],
      package_id: data ? data.package_id : null,
      description_package: null,
      unitary_value: 0,
      lease: false,
      subtotal: 0,
      cost: 0,
      subtotal_cost: 0,
      monthly_result_value: 0,
      monthly_cost_value: 0,
      package_custom: null,
      quantity_custom: null,
      isPriceCost: false,
      priceProduct: 0,
    });
  }

  inflatorVisible: boolean = true;
  deflatorVisible: boolean = false;

  inputControl(item?) {
    this.formProduct
      .get(item ? 'valuePositive' : 'valueNegative')
      .patchValue(0);
    this.inflatorVisible = item ? false : true;
    this.deflatorVisible = item ? true : false;
  }

  updateProductValues() {
    this.swalUtil.swalWithBootstrapButtons
      .fire({
        title: 'Atualizar Produtos?',
        text: 'Você não poderá reverter isso!',
        icon: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, continuar!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          const updateProductSubscription: Subscription = this.budgetService
            .updateBudgetProductValues(this.budgetId)
            .subscribe({
              next: ({ message }: any) => {
                this.swalUtil.success(message);
                this.onUpdateProductValues.emit(this.budgetId);
              },
              error: () => {
                this.swalUtil.error(
                  'Houve um erro ao atualizar Produtos do Orçamento'
                );
              },
              complete: () => updateProductSubscription.unsubscribe(),
            });
        } else {
          this.swalUtil.warning('Operação Cancelada com Sucesso');
        }
      });
  }

  selectProduct() {
    const product = this.formProduct.get(`product`)?.value;
    if (!product) return;
    if (!product?.ml_products_table_versions_prices?.product?.category_id) {
      this.dialog
        .open(ModalAddCategoryComponent, {
          width: '60%',
          data: this.categories,
          disableClose: true,
        })
        .afterClosed()
        .subscribe((data) => {
          product.ml_products_table_versions_prices.product.category = data;
          this.productService
            .updatProductCategory(
              product.ml_products_table_versions_prices.product.id,
              { category_id: data }
            )
            .toPromise()
            .then((data) => {
              this.swalUtil.success('Categoria atribuída com sucesso!');
            });
        });
    }

    if(product.product_supplier.length){
      this.dialog.open(SelectSupplierProductComponent, {
        width: '60%',
        data: product,
        disableClose: true
      }).afterClosed().subscribe((result) => {
        console.log(result)
        this.formProduct.value.product.sale_value = result.sale_price;
        this.formProduct.value.priceProduct = result.sale_price;
        this.formProduct.value.unitary_value = result.sale_price;
        this.formProduct.value.end_price = result.sale_price;
        console.log({form: this.formProduct, product: result})
      })
    }

    if (this.isProductWithClientRule(product.id)) {
      const productRule = product.codes.find(
        (rule) => rule.client_id === Number(this.client_id)
      );

      this.formProduct.patchValue({
        unitary_value: productRule.value,
        cost: product.cost_value,
        code_tuss: product.ml_products_table_versions_prices.product.tuss,
      });
    } else {
      this.formProduct.patchValue({
        unitary_value: product.price,
        cost: product.cost_value,
        code_tuss: product.ml_products_table_versions_prices.product.tuss,
      });
    }
  }

  allCategories() {
    this.loadingCategories = true;
    this.inscricao = this.categoryService.getCategories().subscribe({
      next: (data) => {
        this.categories = data;
        this.loadingCategories = false;
      },
      error: (err) => {
        this.swalUtil.error(
          'Houve algum erro ao buscar as Categorias!',
          'Não foi possível encontrar Categorias'
        );
        this.loadingCategories = false;
      },
    });
  }

  addProduct() {
    let produto = this.ml_package_products_list.find(
      (x) => x.product?.id == this.formProduct.value.product.id
    );
    let id = this.ml_package_products_list.find(
      (x) => x.ml_products_company?.id == this.formProduct.value.product.id
    );

    if (produto || id) {
      this.swalUtil.info(
        'Este produto já foi adicionado!',
        'Não foi possível adicionar o produto'
      );
    } else {
      this.swalUtil.success(
        'O Produto foi adicionado com sucesso!',
        'Produto adicionado'
      );
      this.ml_package_products_list.push(this.formProduct.value); // Adiciona na lista
      this.ml_package_products.push(this.formProduct.value); // Adiciona no item a ser inserido na base de dados
      this.formProduct.patchValue({
        product: null,
        quantity: 1,
        price: 0,
        unitary_value: 0,
        lease: false,
        subtotal: 0,
        cost: 0,
        subtotal_cost: 0,
        monthly_result_value: 0,
        monthly_cost_value: 0,
        description_package: '',
        end_price: 0,
        valueNegative: 0,
        valuePositive: 0,
        inflator: 0,
        deflator: 0,
        ml_products_table_versions_prices: this.formBuilder.group({
          product: this.formBuilder.group({
            description:
              this.formProduct.value.product.ml_products_table_versions_prices
                .product.description,
          }),
        }),
      });
      this.changeProductListEvent.emit(this.ml_package_products_list);
    }
  }

  deleteProduct(item) {
    let index = this.ml_package_products_list.indexOf(item);
    this.swalUtil.popupChoiceMessage(
      'Você não poderá reverter isso!',
      {
        cancelButtonText: 'Não, cancelar',
        confirmButtonText: 'Sim, apagar',
        reverseButtons: true,
        title: 'Deseja apagar produto?',
      },
      () =>
        new Promise<SwalResultMessage>((resolve) => {
          if (item.id) {
            if (this.formType == 'PACKAGE') {
              this.inscricao = this.packageService
                .excluirItemPacoteProduto(item.id)
                .subscribe(() => {
                  this.ml_package_products_list.splice(index, 1);
                  resolve({
                    text: 'O Produto foi deletado com sucesso!',
                    title: 'Produto deletado',
                  });
                });
            } else {
              this.inscricao = this.budgetService
                .excluirItemBudgetProduto(item.id)
                .subscribe(() => {
                  this.ml_package_products_list.splice(index, 1);
                  resolve({
                    text: 'O Produto foi deletado com sucesso!',
                    title: 'Produto deletado',
                  });
                });
            }
          } else {
            this.ml_package_products_list.splice(index, 1);
            resolve({
              text: 'O Produto foi deletado com sucesso!',
              title: 'Produto deletado',
            });
          }
        }),
      () =>
        new Promise<SwalResultMessage>((resolve) => {
          resolve({
            text: 'O Produto não foi deletado!',
            title: 'A Operação foi cancelada',
          });
        })
    );
    this.changeProductListEvent.emit(this.ml_package_products_list);
  }

  isProductWithClientRule(product_company_id: number) {
    let product = this.products.find(
      (product) => product.id === product_company_id
    );

    if (product && this.client_id) {
      let clients = product.codes.filter(
        (rule) => rule.client_id === Number(this.client_id)
      );

      return clients.length;
    }

    return false;
  }

  onChangeTable(table: string) {
    this.selectedTable = table;
    this.loadingVersion = true;
    this.inscricao = this.productService
      .getAllVersionFromTable(table)
      .subscribe((res) => {
        this.loadingVersion = false;
        this.tableVersions = res;
      });
  }

  onChangeTableVersion(version: string) {
    this.loadingProducts = true;
    this.inscricao = this.productService
      .getProductFromTableVersion(this.selectedTable, version, this.client_id)
      .subscribe((res) => {
        this.loadingProducts = false;
        this.products = res;
      });
  }

  openDialogViewKit(kit) {
    const dialogRef = this.dialog.open(ViewKitComponent, {
      data: kit,
      width: '80%'
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }
}
